import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { API_URL } from "../../../srevices/api";

export const fetchCaptcha = createAsyncThunk("captcha/fetchCaptcha", async () => {
    const { data } = await axios.get(`${API_URL}captcha`);
    return data;
  });